import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { NewsArticle } from './news-article.model';
import { NewsArticlePopupService } from './news-article-popup.service';
import { NewsArticleService } from './news-article.service';

@Component({
    selector: 'jhi-news-article-delete-dialog',
    templateUrl: './news-article-delete-dialog.component.html'
})
export class NewsArticleDeleteDialogComponent {

    newsArticle: NewsArticle;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private newsArticleService: NewsArticleService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['newsArticle']);
    }

    clear () {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete (id: number) {
        this.newsArticleService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'newsArticleListModification',
                content: 'Deleted an newsArticle'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-news-article-delete-popup',
    template: ''
})
export class NewsArticleDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor (
        private route: ActivatedRoute,
        private newsArticlePopupService: NewsArticlePopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.newsArticlePopupService
                .open(NewsArticleDeleteDialogComponent as Component, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/news-article/news-article-delete-dialog.component.ts